import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResetterService } from './resetter.service';
import { Resetable } from './resetable';
import { AppParameterService } from '../app-parameter/logic/app-parameter.service';
import { ClientStateService } from '../client-state/logic/client-state.service';
import { MenuService } from '../menu/logic/menu.service';
import { RemoteActionService } from '../remote-action/logic/remote-action.service';
import { ResourceManagerService } from '../resource-manager/logic/resource-manager.service';
import { AppService } from '../app-service/logic/app.service';
import { EmployeeService } from '../employee/logic/employee.service';
import { CredentialsService } from '../credentials/logic/credentials.service';
import { WorktypesService } from '../worktypes/logic/worktypes.service';
import { BranchesService } from '../branches/logic/branches.service';
import { ArchivesService } from '../archives/logic/archives.service';
import { DynFormsService } from '../dyn-forms/logic/dyn-forms.service';
import { ActivityTypesService } from '../activity-types/logic/activity-types.service';
import { ServicejobsService } from '../servicejobs/logic/servicejobs.service';
import { BranchTypesService } from '../branch-types/logic/branch-types.service';
import { EquipmentsService } from '../equipments/logic/equipments.service';
import { ExtFilesService } from '../ext-files/logic/ext-files.service';
import { EmpJobMappingsService } from '../emp-job-mapping/logic/emp-job-mapping.service';
import { BadgesService } from '../badges/logic/badges.service';
import { MaterialsService } from '../materials/logic/materials.service';
import { PinsService } from '../pins/logic/pins.service';
import { ProcessStepsService } from '../process-steps/logic/process-steps.service';
import { PinTypesService } from '../pin-types/logic/pin-types.service';
import { MaskDefinitionService } from '../mask-definition/logic/mask-definition.service';
import { LocalStatusService } from '../local-status/local-status.service';
import { StockService } from '../stock/logic/stock.service';
import { CargoItemTypesService } from '../cargo-item-types/logic/cargo-item-types.service';
import { TourService } from '../tour/logic/tour.service';
import { OrderItemsService } from '../order-item/logic/order-item.service';
import { CarsService } from '../cars/logic/cars.service';
import { FileManagerService } from '../file-manager/file-manager.service';
import { CargoItemsService } from '../cargo-item/logic/cargo-item.service';
import { PreferencesService } from '../preferences/preferences.service';
import { DeficiencyTicketsService } from '../deficiency-ticket/logic/deficiency-tickets.service';
import { RequiredUserActionsService } from '../required-user-actions/logic/required-user-actions.service';
import { TranslationsService } from '../translations/logic/translations.service';
import { GPSTrackService } from '../gps-track/gps-track.service';
import { JobSectionsService } from '../job-section/logic/job-section.service';
import { MaterialDemandInfosService } from '../materialdemandinfo/logic/materialdemandinfos.service';
import { AccessibilityService } from '../accessibility/accessibility.service';
import { MessagesService } from '../message/logic/message.service';
import { AppTasksService } from '../app-tasks/logic/app-tasks.service';
import { FunctionGroupsService } from '../function-group/logic/function-groups.service';
import { ObjectIdLabelService } from '../object-id-label/logic/object-id-label.service';
import { APIService } from '../api/api.service';
import { CellphonesService } from '../cellphones/logic/cellphones.service';
import { ProjectContactDirectoryService } from '../project-contact-directory/logic/project-contact-directory.service';
import { ActivityConfirmationsService } from '../activity-confirmations/logic/activity-confirmations.service';
import { PersonsService } from '../persons/logic/persons.service';
import { BranchFunctionGroupsService } from '../branch-function-groups/logic/branch-function-groups.service';
import { EmployeeFunctionGroupsService } from '../employee-function-groups/logic/employee-function-groups.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: Resetable,
      useExisting: ActivityTypesService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: AppParameterService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: AppService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: ArchivesService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: BranchTypesService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: BranchesService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: CarsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: CargoItemTypesService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: CargoItemsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: ClientStateService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: CredentialsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: DynFormsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: EmpJobMappingsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: EmployeeService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: EquipmentsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: ExtFilesService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: JobSectionsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: MaskDefinitionService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: MenuService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: ProcessStepsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: FunctionGroupsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: PinsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: PinTypesService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: RemoteActionService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: ResourceManagerService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: ServicejobsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: StockService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: TourService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: DeficiencyTicketsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: WorktypesService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: BadgesService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: MaterialsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: LocalStatusService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: OrderItemsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: FileManagerService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: PreferencesService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: RequiredUserActionsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: TranslationsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: GPSTrackService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: MaterialDemandInfosService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: AccessibilityService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: MessagesService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: AppTasksService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: ObjectIdLabelService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: APIService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: CellphonesService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: ProjectContactDirectoryService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: ActivityConfirmationsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: PersonsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: BranchFunctionGroupsService,
      multi: true,
    },
    {
      provide: Resetable,
      useExisting: EmployeeFunctionGroupsService,
      multi: true,
    },
    ResetterService,
  ],
})
export class ResetterModule {}
